
import { combineReducers } from 'redux';
import nation from './nation/reducer';

export default combineReducers({
  nation,
});
